export default "__VITE_ASSET__CaO9Fc$6__"